export default ".dx-button{width:150px}";